/**
 * Builds lifecycle handlers for the Interactive Site Map mobile drawer.
 *
 * @param {Function} dispatch       - Redux dispatch function
 * @param {object}   uiStateActions - uiStateSlice action creators (uses drawerInformation)
 * @param {string}   drawerName     - Drawer identifier (e.g. DRAWER_ID from drawer.plugin)
 * @returns {{ onDrawerReady: Function }}
 */
function createDrawerLifecycleHandlers(dispatch, uiStateActions, drawerName) {
  const onDrawerReady = () => {
    dispatch(uiStateActions.drawerInformation({ name: drawerName }));
  };

  const onDrawerClosed = () => {
    dispatch(uiStateActions.drawerInformation(null));
  };

  return { onDrawerReady, onDrawerClosed };
}

export default createDrawerLifecycleHandlers;